import React from 'react';
import { Phone } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative bg-gray-900 text-white" data-id="element-165">
      {/* Background image with overlay */}
      <div className="absolute inset-0 bg-black opacity-60 z-10" data-id="element-166"></div>
      <div className="absolute inset-0 bg-cover bg-center z-0" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1613685703237-6825649d855d?q=80&w=1920&auto=format&fit=crop')"
    }} data-id="element-167"></div>
      {/* Content */}
      <div className="container mx-auto px-4 py-20 md:py-32 relative z-20" data-id="element-168">
        <div className="max-w-3xl" data-id="element-169">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-170">
            Professional Building Maintenance Services
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200" data-id="element-171">
            Comprehensive maintenance solutions for residential and commercial
            properties in Ajman and Dubai
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-172">
            <a href="#contact" className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-md text-center text-lg font-medium transition-colors" data-id="element-173">
              Get a Free Quote
            </a>
            <a href="tel:+971507583460" className="flex items-center justify-center bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-6 py-3 rounded-md text-lg font-medium transition-colors" data-id="element-174">
              <Phone size={20} className="mr-2" data-id="element-175" />
              +971 50 758 3460
            </a>
          </div>
        </div>
      </div>
    </section>;
}